// 家访列表
export default [
  {
    path: "/list",
    name: "List",
    component: () => import("@/views/List/List.vue"),
    meta: {
      title: "客户列表",
    },
  },
  {
    path: "/list/create",
    name: "ListCreate",
    component: () => import("@/views/List/Create.vue"),
    meta: {
      title: "新增客户",
    },
  },
  {
    path: "/detail/:id",
    name: "Detail",
    component: () => import("@/views/Detail/Detail.vue"),
    meta: {
      title: "客户详情",
    },
  },
  {
    path: "/list/case",
    name: "ListCase",
    component: () => import("@/views/List/ListCase.vue"),
    meta: {
      title: "线索列表",
    },
  },
  {
    path: "/list/case/create",
    name: "ListCaseCreate",
    component: () => import("@/views/List/Create.vue"),
    meta: {
      title: "新增线索",
    },
  },
  {
    path: "/file-viewer",
    name: "FileViewer",
    component: () => import("@/views/FileViewer/viewer.vue"),
    meta: {
      title: "查看PDF",
    },
  },
  {
    path: "/follow",
    name: "Follow",
    component: () => import("@/views/List/Follow.vue"),
    meta: {
      title: "跟进",
      keepAlive: true,
    },
  },
  {
    path: "/relation",
    name: "Relation",
    component: () => import("@/views/Relation/List.vue"),
    meta: {
      title: "联系人列表",
    },
  },
  {
    path: "/relation/create",
    name: "RelationCreate",
    component: () => import("@/views/Relation/Create.vue"),
    meta: {
      title: "联系人",
    },
  },
  {
    path: "/calendar",
    name: "Calendar",
    component: () => import("@/views/Map/calendar.vue"),
    meta: {
      title: "calendar",
    },
  },
];
